jQuery(function($)
{
    var
        classVisible = 'visible',
        $scrollToTop = $('#scroll-to-top'),
        $document = $(document),
        mainOffset = $('main').offset().top,
        bottomPosition = 9; // $basepadding (9px)

    function show($el)
    {
        $el.addClass(classVisible);
        handleHeight($el);
    }

    function hide($el)
    {
        $el.removeClass(classVisible);
    }

    function updateScrollToTop()
    {
        if ($document.scrollTop() > mainOffset)
        {
            show($scrollToTop);
        }
        else
        {
            hide($scrollToTop);
        }
    }

    function handleScroll()
    {
        updateScrollToTop();
    }

    function handleClick(e)
    {
        e.preventDefault();

        $('body, html').animate({
            'scrollTop': 0
        }, '500', 'swing');
    }

    function handleHeight($el)
    {
        let fixedBanner = document.querySelector('.js-fixed-banner');
        if (fixedBanner && !fixedBanner.classList.contains('fixed-banner__closed'))
        {
            let fixedBannerHeight = fixedBanner.offsetHeight + bottomPosition;
            $el.get(0).style.setProperty('--dynamic-bottom', fixedBannerHeight + 'px');
        }
        else if (orion.getShopViewCode() == 'desktop')
        {
            $el.get(0).style.setProperty('--dynamic-bottom', 85 + 'px');  // gleiche Höhe wie FixedBanner geschlossen
        }
        else
        {
            $el.get(0).style.setProperty('--dynamic-bottom', 28 + 'px');  // gleiche Höhe wie FixedBanner geschlossen
        }
    }

    function handleBannerState()
    {
        handleHeight($scrollToTop);
    }

    function initialize()
    {
        updateScrollToTop();
    }

    document.addEventListener('fixedBannerClosed', handleBannerState);
    document.addEventListener('fixedBannerOpen', handleBannerState);

    initialize();

    $document.on('scroll', handleScroll);

    $scrollToTop.on('click', handleClick);
});
